import { Helmet } from 'react-helmet-async';
import { Container, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 1280,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(20, 0),
}));

export default function InstructionsPage() {
  return (
    <>
      <Helmet>
        <title> VPSI | Help </title>
      </Helmet>

      <Container>
        <StyledContent>
          <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
            <Typography variant="h4" gutterBottom>
              Help
            </Typography>
          </Stack>
          <Stack direction="column" alignItems="center" justifyContent="space-between" gap={2} width={'100%'}>
            {Array.from({ length: 9 }).map((_, index) => (
              <img key={index} src={`/assets/images/help/help ${index}.svg`} alt={`VPSI help ${index + 1}`} />
            ))}
          </Stack>
        </StyledContent>
      </Container>
    </>
  );
}
